<div class="modal-body exception-modal" [ngClass]="{'entity-deletion':deleteEntityModal}"
  role="dialog" aria-modal="true" cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
  [attr.aria-label]="titleText">
  <div class="modal-header">
    <div class="user-icon-title-container">
      <div *ngIf="confirmationLevel === 2 && deleteEntityModal"
        class="back-btn txt-white lato-16-n-vw" (click)="returnToLevel1()" role="button"
        tabindex="0" aria-label="Back" (keydown.enter)="returnToLevel1(); $event.preventDefault()"
        (keydown.space)="returnToLevel1(); $event.preventDefault()">
        <span class="arrow-label">
        </span>
        Back
      </div>
      <!-- <div
        *ngIf="isSvgVisible && svgName !== '' && !isFromRiskAiConfonfirmation && !isFromGlobalControls && svgName !== 'reminder-icon' && modalType !== MODAL_TYPE_ENUM.UNLINK_ARTIFACT && svgName !== 'unlink'"
        class="user-icon" cygovSvgIcon [svgName]="svgName">
      </div> -->

      <div class="user-robot-icon" *ngIf="isFromRiskAiConfonfirmation" cygovSvgIcon
        [svgName]="'robots-type1'" aria-label="Robot Icon"></div>

      <ng-container
        *ngIf="svgName !== '' && !isFromRiskAiConfonfirmation && svgName !== 'reminder-icon' && modalType !== MODAL_TYPE_ENUM.UNLINK_ARTIFACT && svgName !== 'unlink'">
        &nbsp;
      </ng-container>
      <ng-container>
        @if(modalType === MODAL_TYPE_ENUM.UNLINK_ARTIFACT || svgName === 'unlink'){
        <span class="unlink-header-text">
          UNLINK ARTIFACT
        </span>
        }@else if(MODAL_TYPE_VALUES.includes){
        <span class="lato-18-n-vw text-white">
          {{ titleText }}
        </span>
        }@else {
        <span [ngClass]="{'lato-24-n-vw': !isFromGlobalControls}">
          {{ titleText }}
        </span>
        }

      </ng-container>
    </div>
    <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'" (click)="hideModal()"
      role="button" tabindex="0" aria-label="Close modal"
      (keydown.enter)="hideModal(); $event.preventDefault()"
      (keydown.space)="hideModal(); $event.preventDefault()">
    </div>
  </div>
  <div class='modal-content-body'
    [ngClass]="{'deny-modal-height' : svgName?.toLowerCase() === 'deny', 'modal-content-body-risk-group' : isFromRiskGroup}">

    <!-- Level 1 Box -->
    <div class='confirmation-level-{{ confirmationLevel }}'
      *ngIf="confirmationLevel === 1; else level2Box;"
      [ngClass]="{'confirmation-level-risk-group' : isFromRiskGroup}">
      <div class="lato-18-n-vw message" *ngIf="svgName === 'archive-questionnaire'"
        style="margin-bottom: 1rem;">
        <div style="padding-bottom: 1vh;">
          Please note you are about to archive <span class="text-blue">{{ questionnaireName
            }}</span> questionnaire.
        </div>
        <div>{{ svgNameDescription['archive-questionnaire'][1] }}</div>
      </div>
      <div class="lato-18-n-vw message"
        *ngIf="!isCustomContent && !isFromRiskAiConfonfirmation && !isFromRiskGroup && (svgName == 'reminder-icon' || isFromScans) && modalType !== MODAL_TYPE_ENUM.UNLINK_ARTIFACT && svgName !== 'unlink'">
        Please note you are about to {{removeOrCloseText}} <br *ngIf="showLineBreak">
        <span *ngIf="!deleteEntityModal" class="remove-label-text">{{ removeLabelText }}</span>
        <span *ngIf="!isConfirm2Required || removeFromText.length" class="from-text">
          {{removeFromText}}</span>
        <span *ngIf="deleteEntityModal"><span class='txt-blue'>{{ removeLabelText }}</span>
          {{entityType}}</span><br>
        <span *ngIf="deleteEntityModal && showPermanentText">{{show2ndConfirmText ?
          show2ndConfirmText:'All of its data will be erased permanently'}}</span>
      </div>
      <div class="lato-18-n-vw message" *ngIf="isFromRiskGroup && !isDeleteGroup">
        Please note you are about to {{removeOrCloseText}} risk:<br *ngIf="showLineBreak">
        <span class="remove-label-text">"{{ riskName }} | {{ riskId }}"</span>&nbsp;
        <span class='from-label'>from group <span class="text-blue">{{ groupName}}</span></span>

      </div>
      <div class="lato-18-n-vw message" *ngIf="isFromRiskGroup && isDeleteGroup">
        Please note that you are about to permanently {{removeOrCloseText}} group:
        <span class="remove-label-text">{{ riskId }}</span>&nbsp;
      </div>

      <div class="lato-18-n-vw message risk-ai-message" *ngIf="isFromRiskAiConfonfirmation">
        <div class="p1">The Centraleyes AI module leverages a third-party generative AI engine to
          automate
          risk creation and mapping, efficiently identifying and evaluating potential risks
          through advanced algorithms. Beyond the recognition of the scenario, it analyzes
          contextual information for a nuanced understanding of each risk and adapts dynamically.

        </div>
        <div class="p2">
          The only data that is shared with the third-party engine is the risk name, industry, and
          description entered by the user
        </div>
        <div class="p3">
          By clicking on confirm below, you approve that the AI
          module will be activated and available to all relevant users.
        </div>
      </div>

      <!-- Global Controls Message  -->
      <div class="global-control-message"
        *ngIf="modalType === MODAL_TYPE_ENUM.DELETE_GLOBAL_CONTROL">
        <div class="p1">
          Please note that you are about to remove the connection to a global control. <br>
        </div>
        <div class="p2">
          Origin: <span class="text-blue"> {{globalControlOrigin}} </span><br>
          Destination: <span class="text-blue">{{globalControlDestination}}</span><br>
        </div>
        <div class="p3">
          Removing the connection will make these controls operate independently.
        </div>
      </div>

      <div class="dynamic-label-manager-message"
        *ngIf="modalType === MODAL_TYPE_ENUM.DELETE_DYNAMIC_LABEL_CHECK">
        <div class="p1">
          Please note, the dynamic label being removed <span class="text-blue"> {{ artifactsCount <=
              2 ? artifactsNames : artifactsNames.length }} </span>
              <br>
              is currently linked to the following items:<br>
              <div class="list-wrapper">
                <ul>
                  @for (item of selectedQuestions; track item; let i = $index) {
                  <li>
                    <span [ngbTooltip]="item.name.length > 30 ? item.name : null"
                      [disableTooltip]="item.name.length <= 30">{{ item.name.length > 30 ?
                      (item.name |
                      slice:0:30) + '...' : item.name }}</span>
                  </li>
                  }
                </ul>
              </div>
        </div>
      </div>

      <div class="dynamic-label-manager-confirm"
        *ngIf="modalType === MODAL_TYPE_ENUM.DELETE_DYNAMIC_LABEL">
        <div class="p1" *ngIf="artifactsCount <= 2">
          Please note <span class="text-blue"> {{ artifactsNames }} </span> <br>
          will be permanently deleted. <br>
        </div>
        <div class="p1" *ngIf="artifactsCount > 2">
          Please note <span class="text-blue"> {{ artifactsCount }} dynamic labels </span>will be
          permanently deleted. <br>
        </div>
      </div>
      <!-- Unlink Artifact Message  -->
      <div class="" *ngIf="modalType === MODAL_TYPE_ENUM.UNLINK_ARTIFACT || svgName === 'unlink'">
        <div class="lato-18-n-vw text-white unlink-heading">
          You are about to unlink {{artifactsCount > 1 ? 'the artifacts' : 'the artifact'}} from the
          following question:
        </div>
        <div class="lato-18-n-vw question-identifier">
          <span class="text-blue question-link" (click)="onQuestionClick()" role="button"
            tabindex="0" [attr.aria-label]="'Open question ' + questionIdentifier"
            (keydown.enter)="onQuestionClick(); $event.preventDefault()"
            (keydown.space)="onQuestionClick(); $event.preventDefault()">{{questionIdentifier}}</span>
        </div>
      </div>

      <!-- Action Consequence (separate from unlink message) -->
      <div class="lato-18-n-vw action-consequence"
        *ngIf="modalType === MODAL_TYPE_ENUM.UNLINK_ARTIFACT || svgName === 'unlink'">
        This action will remove {{artifactsCount > 1 ? 'the artifacts' : 'the artifact'}} from this
        question.
      </div>

      <div class="lato-16-n-vw message" *ngIf="isCustomContent && !deleteFrameworkText">
        <span>{{svgNameDescription[svgName]?.join('')}}</span><br>
        <span *ngIf="artifactsNames?.length > 0" class="text-blue" [ngbTooltip]="artifactsNames[0]"
          [disableTooltip]="!showColumnTooltip" (mouseenter)="showColumnTooltip=true"
          (mouseleave)="showColumnTooltip=false">{{artifactsNames[0]}}</span>
      </div>
      <div class="lato-16-n-vw message"
        *ngIf="isCustomContent && deleteFrameworkText && !isFromPolicyManagement">
        <span>{{deleteFrameworkText}}</span><br>
        <span *ngIf="artifactsNames?.length > 0" class="text-blue">"{{artifactsNames}}"</span><br>
      </div>
      @if(isCustomContent && isFromPolicyManagement){
      <div class="lato-16-n-vw message">
        <div class="lato-18-n-vw text-white">Please note you are about to permanently delete <br>
          the policy template: <span class="lato-18-n-vw text-blue">"{{ removeLabelText }}"</span>
        </div>
      </div>
      }
      @if(isCustomContent && isFromPolicyTable){
      <div class="lato-16-n-vw message">
        <div class="lato-18-n-vw text-white">Please note you are about to permanently delete the
          policy <br>
          <span class="lato-18-n-vw text-blue">"{{ removeLabelText }}"</span>
        </div>
      </div>
      }

      @if(isFromGraphDeletion){
      <div class="lato-16-n-vw message">
        <div class="lato-18-n-vw text-white">Please note you are about to {{removeOrCloseText}}
          <span class="lato-18-n-vw text-blue">"{{ removeLabelText }}"</span><br>
          from the reports history section
        </div>
      </div>
      }

      @if(isFromBinaryEdgeTable){
      <div class="lato-18-n-vw message">
        <div class="lato-18-n-vw text-white">Please note you are about to delete
          @if(artifactsCount <= 3){ <span class="lato-18-n-vw text-blue">"{{ removeLabelText
            }}"</span>
            } @else {
            <span class="lato-18-n-vw text-blue">{{ artifactsCount }}</span> breaches
            }
        </div>
      </div>
      }

      @if(isFromUserSettings){
      <div class="lato-16-n-vw message">
        <div class="lato-18-n-vw text-white">Please note you are about to {{removeOrCloseText}} <br>
          <span class="lato-18-n-vw text-blue">"{{ removeLabelText }}"</span> {{removeFromText}}
        </div>
      </div>
      }

      <!-- Vendor Delete Questioner -->
      <div *ngIf="modalType === MODAL_TYPE_ENUM.DELETE_QUESTIONNAIRE_VENDOR"
        style="margin-bottom: 3vh;">
        <div class="lato-18-n-vw message ">
          <span> Please note that you are about to remove <br>
          </span>
          <span class="text-blue">{{deleteFrameworkName}} &nbsp; framework</span>
        </div>
      </div>

      <!-- Archive Confirmation -->
      <div class="lato-16-n-vw delete-confirm" *ngIf="svgName === 'archive-questionnaire'"
        [ngClass]="{'delete-confirm-ai' : isFromRiskAiConfonfirmation}">
        Type the word <span class="confirm-txt"
          [ngClass]="{'confirm-text-ai' : isFromRiskAiConfonfirmation}"
          (click)="copyToClipboard('confirm')" role="button" tabindex="0"
          aria-label="Copy confirm text"
          (keydown.enter)="copyToClipboard('confirm'); $event.preventDefault()"
          (keydown.space)="copyToClipboard('confirm'); $event.preventDefault()">&nbsp;&quot;confirm&quot;&nbsp;</span>
        to &nbsp; archive
        <input [(ngModel)]="confirmationString" type="text" #confirmation="ngModel"
          class="delete-input" placeholder="confirm"
          (keyup)="onValueChanged(confirmation?.value)" />
      </div>

      <!-- Vendor Delete Section -->
      <div *ngIf="modalType === MODAL_TYPE_ENUM.DELETE_VENDOR">
        <div class="lato-18-n-vw message">
          <span> Please note that you are about to remove <br>
          </span>
          @if (vendorsCount <= 3) { <span class="text-blue">
            {{vendorNames}} &nbsp;
            </span>
            } @else{
            <span class="venders-count"> {{vendorsCount}} </span>
            }
            <span>{{vendorsCount=== 1 ? 'vendor' : 'vendors'}}</span>

        </div>
      </div>

      <!-- Unlink Confirmation -->
      <div class="lato-16-n-vw delete-confirm unlink-confirm"
        *ngIf="modalType === MODAL_TYPE_ENUM.UNLINK_ARTIFACT || svgName === 'unlink'">
        Type the word <span class="confirm-txt" (click)="copyToClipboard('confirm')" role="button"
          tabindex="0" aria-label="Copy confirm text"
          (keydown.enter)="copyToClipboard('confirm'); $event.preventDefault()"
          (keydown.space)="copyToClipboard('confirm'); $event.preventDefault()">&nbsp;&quot;confirm&quot;&nbsp;</span>
        to &nbsp; unlink
        <input [(ngModel)]="confirmationString" type="text" #confirmation="ngModel"
          class="delete-input" placeholder="confirm"
          (keyup)="onValueChanged(confirmation?.value)" />
      </div>

      <!-- Generic Confirmation -->
      <div>
        <span class="lato-18-n-vw text-white"
          *ngIf="deleteEntityModal && !isFromGlobalControls && modalType !== MODAL_TYPE_ENUM.DELETE_VENDOR">Please
          note you are about to
          remove the <span class="lato-18-n-vw text-blue">{{removeLabelText}}</span>
          entity.<br></span>
        <div class="lato-16-n-vw delete-confirm"
          *ngIf="isSvgVisible && svgName !== 'deny' && svgName !== 'approve' && svgName !== 'gap' && svgName !== 'reminder-icon' && svgName !== 'archive-questionnaire' && svgName !== 'unlink' && modalType !== MODAL_TYPE_ENUM.UNLINK_ARTIFACT"
          [ngClass]="{'delete-confirm-ai' : isFromRiskAiConfonfirmation}">
          Type the word <span class="confirm-txt"
            [ngClass]="{'confirm-text-ai' : isFromRiskAiConfonfirmation}"
            (click)="copyToClipboard('confirm')" role="button" tabindex="0"
            aria-label="Copy confirm text"
            (keydown.enter)="copyToClipboard('confirm'); $event.preventDefault()"
            (keydown.space)="copyToClipboard('confirm'); $event.preventDefault()">&nbsp;&quot;confirm&quot;&nbsp;</span>
          to &nbsp;

          <span *ngIf="!isFromRiskAiConfonfirmation">delete</span>
          <span *ngIf="isFromRiskAiConfonfirmation">activate</span>
          <input [(ngModel)]="confirmationString" type="text" #confirmation="ngModel"
            class="delete-input" placeholder="confirm"
            (keyup)="onValueChanged(confirmation?.value)" />
        </div>
      </div>
      <div class="lato-16-n-vw delete-confirm"
        *ngIf="!isSvgVisible && svgName !== 'deny' && svgName !== 'approve' && svgName !== 'gap' && svgName !== 'reminder-icon' && svgName !== 'archive-questionnaire' && svgName !== 'unlink' && modalType !== MODAL_TYPE_ENUM.UNLINK_ARTIFACT"
        [ngClass]="{'delete-confirm-ai' : isFromRiskAiConfonfirmation}">
        Type the word <span class="confirm-txt"
          [ngClass]="{'confirm-text-ai' : isFromRiskAiConfonfirmation}"
          (click)="copyToClipboard('confirm')" role="button" tabindex="0"
          aria-label="Copy confirm text"
          (keydown.enter)="copyToClipboard('confirm'); $event.preventDefault()"
          (keydown.space)="copyToClipboard('confirm'); $event.preventDefault()">&nbsp;&quot;confirm&quot;&nbsp;</span>
        to &nbsp;

        <span *ngIf="!isFromRiskAiConfonfirmation">delete</span>
        <span *ngIf="isFromRiskAiConfonfirmation">activate</span>
        <input [(ngModel)]="confirmationString" type="text" #confirmation="ngModel"
          class="delete-input" placeholder="confirm"
          (keyup)="onValueChanged(confirmation?.value)" />
      </div>
      <div class="lato-16-n-vw comment-textbox" *ngIf="svgName === 'deny' || svgName === 'gap'">
        <span class="comment-heading">{{commentHeading}}</span>
        <textarea class="explain-answer lato-14-n-vw" [(ngModel)]="comment"
          (keyup)="onValueChanged(comment)"></textarea>
      </div>

      <!-- Vendor Reminder Section -->
      <div *ngIf="modalType === MODAL_TYPE_ENUM.SEND_REMINDER_VENDOR">
        <div class="lato-18-n-vw message">
          <span> Please note that you are about to send an <br>
            assessment completion reminder to
          </span>
          @if (vendorsCount <= 3) { <span class="text-blue">
            <br> {{vendorNames}}
            </span>
            } @else{
            <span class="venders-count"> {{vendorsCount}} vendors.</span>
            }

        </div>
      </div>
    </div>

    <!-- Level 2 Box -->
    <ng-template #level2Box>
      <div class="confirmation-level-{{ confirmationLevel }} lato-18-n-vw">
        {{confirmationLevel2Text}}
      </div>
      <div *ngIf="show2ndConfirmText" class="second-message txt-white lato-18-n-vw">
        {{show2ndConfirmText}}
      </div>
    </ng-template>

  </div>
  <ng-container *ngIf="svgName === 'reminder-icon' ; else defaultFooter">
    <div class="modal-content-footer gap-footer">
      <div class="d-flex">
        <cygov-button class="button-margin" [buttonText]="'SEND'" [buttonWidth]="'5vw'"
          [buttonColor]="'#29a9eb'" (click)="confirmLevel()" [hoverColor]="'#0F92E3'">
        </cygov-button>

        <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonColor]="'#030715'"
          [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5vw'" [textColor]="'#C5C9D1'"
          (click)="hideModal()">
        </cygov-button>
      </div>
    </div>
  </ng-container>

  <ng-template #defaultFooter>
    <div class="modal-content-footer"
      [ngClass]="{'gap-footer': svgName === 'deny' || svgName === 'gap'}">
      <div class="d-flex">
        <cygov-button class="button-margin" [buttonText]="'CONFIRM'" [buttonWidth]="'5vw'"
          [buttonColor]="'#29a9eb'" (click)="confirmLevel()" [hoverColor]="'#0F92E3'"
          [disableClick]="!confirmationString" [fullyDisabled]="!confirmationString">
        </cygov-button>

        <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonColor]="'#030715'"
          [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5vw'" [textColor]="'#C5C9D1'"
          (click)="hideModal()">
        </cygov-button>
      </div>
    </div>
  </ng-template>
</div>